import { default as Item } from './item'
import listComponent from '@/util/proto/listComponent'

export default {
  extends: listComponent,
  data() {
    return {
      columns: [{
          title: '价格',
          key: 'price',
          width: 100,
        },
        
        {
          title: '区域',
          minWidth:150,
          render:(h , {row}) => {
            return (row.districtNames || []).map(i => <span style="margin-right:3px;">{i}</span>)
          }
        },
        {
          title: '操作',
          key: 'operation',
          width: 200,
          align: 'center',
          fixed: 'right',
          render: (h, { row }) => {
            
            let acts = [
              <a v-permission="ass.feetpl.update" on-click={()=>this.edit(row)}>编辑</a>,
              <a v-permission="ass.feetpl.delete" on-click={()=>this.remove(row)}>删除</a>
            ]
            return this.$utils.link(acts,<Divider type="vertical" />)
          }
        }
      ],
      data: [],
      params: {

      },
      page: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      loading: false,
    }
  },

  created() {
    this.def = { ...this.params }
    this.search()
  },

  methods: {
    search() {
      let params = { search: { ...this.params }, pageSize: this.page.pageSize, pageNum: this.page.pageNum }
      this.loading = true
      this.$request.assFeeTpls(params).then(resp => {
        this.loading = false
        if (!resp.code) {
          this.data = resp.data.list
          this.page.total = resp.data.total || 0
        }
      })
    },
    create(){
      this.$refs['item'].init()
    },
    reset(){
      this.$utils.fill(this.params, this.def)
      this.search()
    },
    edit(record) {
      this.$refs['item'].init(record.id)
    },

    remove(record) {
      this.$ui.confirm(this.$request.assFeeTplDelete, `确定删除维修师 ${record.name}？`)(record.id).then(resp => {
        if (!resp.code) {
          this.$Message.success('删除成功')
          this.search()
        } else {
          this.$Message.error({ content: resp.msg })
        }
      })
    },
   
    handleUpdate() {
      this.search()
    },
  },

  render() {
    return (
      <sl-page>
        <div class="page-filter">
           <Button v-permission="ass.feetpl.insert" type="primary" icon="md-add" on-click={this.create}>新增</Button>
        </div>
        <div class="pg-bd">
          <sl-table loading={this.loading} page={this.page} columns={this.columns} data={this.data} on-change={this.$tableChange}>
          </sl-table>
        </div>
        <Item ref="item" on-update={this.handleUpdate} />
      </sl-page>
    )
  }
}
